import * as React from 'react';
import { useFilterParamsContext } from '../filter_main/model/filter_params';
import { ServiceBlock } from './ui/service_block';

/**
 * @param {Object} props
 * @param {string} props.service_name
 * @param {string} props.condition_param
 * @param {Function} props.filter
 * @param {Array} props.value
 * @param {Object} props.counts
 * @param {string} props.filterParamsProperty
 * @param {boolean} props.show_chosen
 * @return {React.JSX.Element|null}
 * @constructor
 */
export const ServiceTags = ({ filterParamsProperty, ...props }) => {
  const { filterParams } = useFilterParamsContext();
  const campServiceTags = filterParams[filterParamsProperty] ?? [];

  const isChecked = (id) => {
    return (props.value || []).includes(String(id));
  };

  const handleChange = (event) => {
    let newValue = [...(props.value || [])];

    if (event.target.checked) {
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter((v) => v != event.target.value);
    }

    return props.filter(props.condition_param, newValue.length === 0 ? false : newValue);
  };

  const tagsToRender = () => {
    if (props.counts) {
      return campServiceTags.filter((item) => isChecked(item.id) || props.counts[item.id] > 0);
    } else {
      return campServiceTags;
    }
  };

  const serviceBlocks = () => {
    return tagsToRender().map((serviceTag, i) => {
      if (!props.show_chosen || isChecked(serviceTag.id)) {
        return <ServiceBlock serviceTag={serviceTag} onChange={handleChange} isChecked={isChecked(serviceTag.id)} counts={props.counts} key={i} />;
      } else return null;
    });
  };

  if (props.show_chosen && (props.value || []).length === 0) {
    return null;
  }
  return (
    <div className='filter-row'>
      <div className='filter-row__title'>{props.service_name}</div>

      {serviceBlocks()}
    </div>
  );
};
